import CampaignsAdminCard from './CampaignsAdminCard';
export default CampaignsAdminCard;
